import { DirectiveOptions } from 'vue';

const NoVirtualKeyboard: DirectiveOptions = {
    bind(inputElement: HTMLElement, binding) {
        const inputModeOnTap = binding.value || 'text';
        inputElement.setAttribute('inputmode', 'none');

        const showKeyboard = () => inputElement.setAttribute('inputmode', inputModeOnTap);
        const hideKeyboard = () => inputElement.setAttribute('inputmode', 'none');

        inputElement.addEventListener('pointerdown', showKeyboard);
        inputElement.addEventListener('blur', hideKeyboard);

        (inputElement as any).__noVirtualKeyboardCleanup = () => {
            inputElement.removeEventListener('pointerdown', showKeyboard);
            inputElement.removeEventListener('blur', hideKeyboard);
        };
    },
    unbind(inputElement: HTMLElement) {
        (inputElement as any).__noVirtualKeyboardCleanup?.();
    },
};

export default NoVirtualKeyboard;
